module.exports = __webpack_public_path__ + "img/79.606fdb34.jpg";